import { CONTACTS_KEY } from "../config/constants";

export function safeParse(key, fallback) {
  try { return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback)); }
  catch (e) { console.warn(`localStorage parse failed for ${key}:`, e); return fallback; }
}
export function safeSet(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); return true; }
  catch (e) { console.warn(`localStorage set failed for ${key} (quota?):`, e); return false; }
}
export function loadContacts() { return safeParse(CONTACTS_KEY, []); }
export function saveContacts(c) { safeSet(CONTACTS_KEY, c); }
export function genId() { return crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36); }
